import { render, staticRenderFns } from "./AppDialog.vue?vue&type=template&id=0cf4b709&scoped=true"
import script from "./AppDialog.vue?vue&type=script&lang=ts"
export * from "./AppDialog.vue?vue&type=script&lang=ts"
import style0 from "./AppDialog.vue?vue&type=style&index=0&id=0cf4b709&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf4b709",
  null
  
)

export default component.exports